module.exports = __webpack_public_path__ + "static/media/DSCF6358.ac0f53c4.jpg";